import vconst from 'utils/helpers/structs/vconst';

export type WarehouseHeaderMeta = {
    type: string;
    typeClass: string;
    badgeClass: string | null;
    name: string | null;
};

type WarehouseHeaderInfo = {
    reservObjectId?: number | null;
    customId?: number | null;
    custom?: { ID?: number; name?: string } | null;
    team?: { ID?: number; teamName?: string } | null;
    object?: { objectName?: string; clientName?: string } | null;
} | null;

type GetWarehouseHeaderParams = {
    wId: number;
    warehouseInfo: WarehouseHeaderInfo;
    teamId: number | null;
    teamName: string;
    customId: number | null;
    customName: string;
    t: (key: string) => string;
};

export const getWarehouseHeader = ({
    wId,
    warehouseInfo,
    teamId,
    teamName,
    customId,
    customName,
    t,
}: GetWarehouseHeaderParams): WarehouseHeaderMeta => {
    if (wId === vconst.waherouseMainId) {
        return {
            type: t('typeMainWarehouse'),
            typeClass: 'text-info',
            badgeClass: null,
            name: null,
        };
    }
    if (wId === vconst.waherouseWriteOffId) {
        return {
            type: t('writeOffWarehouse'),
            typeClass: 'text-danger',
            badgeClass: null,
            name: null,
        };
    }
    if (!warehouseInfo) {
        return {
            type: t('warehouse'),
            typeClass: 'text-muted',
            badgeClass: null,
            name: null,
        };
    }
    if (warehouseInfo.reservObjectId) {
        return {
            type: t('warehouseFilterReserve'),
            typeClass: 'text-warning',
            badgeClass: 'bg-light-warning text-warning',
            name: warehouseInfo.object?.objectName
                || warehouseInfo.object?.clientName
                || null,
        };
    }
    if (warehouseInfo.custom?.ID || warehouseInfo.customId || customId) {
        return {
            type: t('typeCustomWarehouse'),
            typeClass: 'text-info',
            badgeClass: 'bg-light-info text-info',
            name: warehouseInfo.custom?.name || customName || null,
        };
    }
    if (warehouseInfo.team?.ID || teamId) {
        return {
            type: t('teamWarehouse'),
            typeClass: 'text-primary',
            badgeClass: 'bg-light-primary text-primary',
            name: warehouseInfo.team?.teamName || teamName || null,
        };
    }
    return {
        type: t('typeObjectWarehouse'),
        typeClass: 'text-success',
        badgeClass: null,
        name: warehouseInfo.object?.objectName
            || warehouseInfo.object?.clientName
            || null,
    };
};
